// Module
var code = "<input data-bind=\"textInput: Value, attr: { title: Value }\" type=\"text\" class=\"form-control input-sm\" style=\"min-width:100px;max-width:160px;height:34px\">";
// Exports
export default code;